import { BASE_URL, changeBaseUrl, getApiBaseUrl, getResolvedApiUrl } from '../apis/utils/provider';
import { removeItem, getItem, setItem } from './storage';
import { isDevRelease } from '../config/app';

const TEST_API_STORAGE_KEY = 'TEST_API_URL';

export const isTestApiUrlApplied = () => {
  return BASE_URL !== getApiBaseUrl();
};

export const setTestApiUrl = (_url: string) => {
  setItem(TEST_API_STORAGE_KEY, _url);
  changeBaseUrl(_url);
};

export const updateTestApiUrl = async () => {
  const url = getItem(TEST_API_STORAGE_KEY);
  if (isDevRelease() && !!url) {
    changeBaseUrl(url);
  }
};

export const removeTestApiUrl = async () => {
  removeItem(TEST_API_STORAGE_KEY);
  changeBaseUrl(getResolvedApiUrl());
};
